import request from '@/utils/request'

function query (storeID) {
  return request({
    url: '/receiptTemplate/query?store_id=' + storeID,
    method: 'GET'
  })
}

export default {
  query
}
